import React from "react";
import { Link } from "react-router-dom";
import remove from '../../../assets/products/moins.png' 
import { GIFTSWAP_BENEFIT } from "../../../Env";
import Currencies from "../../../lib/Currencies";

const CartItem = ({ item, currency, onUpdateCartQty, onRemoveFromCart ,key, rate}) => {

  const handleUpdateCartQty = (lineItemId, newQuantity) => onUpdateCartQty(lineItemId, newQuantity);

  const handleRemoveFromCart = (lineItemId) => onRemoveFromCart(lineItemId);

  const itemTotal = (item) => {
    return ((item.euroPrice*item.quantity*GIFTSWAP_BENEFIT)/rate)
  }
 
  return (
    <tr key={item.id} >
      <td style={{ width : "18%" }}>
        <Link to={`/products/${item.variantId}`}><img className="m-0" src={item.urlImage} alt={item.fullName}/></Link>
      </td>
      <td className="pl-3">
      <Link to={`/products/${item.variantId}`}><h6>{item.fullName}</h6></Link>
      </td>
      <td>
        <div className="number-input">
          <button onClick={() => handleUpdateCartQty(item.id, item.quantity - 1)}></button>
          <input type="text" name="amount" className="auto-number" value={item.quantity} readOnly={true} />
          <button onClick={() => handleUpdateCartQty(item.id, item.quantity + 1)} className="plus"></button>
        </div>
      </td>
      <td>
        <p>{item.price.toFixed(2)} {Currencies.GetSymbol(item.currency)}</p>
      </td>
      <td>
        {rate == null && <p>---</p>}
        {rate != null && <p>{itemTotal(item).toFixed(4)} {currency}</p>}
      </td>
      <td className="controls">
        <ul> 
          <li onClick={() => handleRemoveFromCart(item.id)}>
            <img className="alert-icon" src={"/icons/trash.svg"}/>
          </li>
        </ul>
      </td>
    </tr>

  );
};

export default CartItem;